import React, { useState, useEffect } from 'react';
import { Users, BookOpen, HeartHandshake } from 'lucide-react';

function ImpactStat() {
    //For counter animations
    const [counters, setCounters] = useState({
        students: 0,
        tutorHours: 0,
        refugeesHelped: 0,
    });

    //Target Value
    const target = {
        students: 100,
        tutorHours: 1000,
        refugeesHelped: 4000,
    }

    //Animation
    useEffect(() => {
        const duration = 2000; //duration in ms
        const frameRate = 30; //frames per sec
        const steps = duration / (1000 / frameRate)

        let frame = 0;
        const interval = setInterval(() => {
            frame++;
            const progress = Math.min(frame / steps, 1)

            setCounters({
                students: Math.floor(target.students * progress),
                tutorHours: Math.floor(target.tutorHours * progress),
                refugeesHelped: Math.floor(target.refugeesHelped * progress)
            });

            if (frame >= steps) {
                clearInterval(interval);
            }
        }, 1000 / frameRate);

        return () => clearInterval(interval);
    }, []);

    return(
        <section className='relative overflow-hidden py-16 bg-gradient-to-r from-secondary to-primary px-10'>
            {/* Bacgroundn decorative elements */}
            <div className='absolute top-0 left-0 w-full h-full'>
                <div className='absolute top-0 left-0 w-20 h-20 rounded-full bg-white opacity-5' />
                <div className='absolute bottom-0 right-0 w-40 h-40 rounded-full bg-white opacity-5' />
                <div className='absolute top-1/2 left-1/4 w-12 h-12 rounded-full bg-white opacity-5' />
            </div>

            <div className='max-w-6xl mx-auto px-6 relative z-10'>
                <div className='text-center mb-10'>
                    <h2 className='font-display text-h3 sm:text-h2 text-white'>Our Impact</h2>
                    <div className='w-16 h-1 bg-cta mx-auto mt-4'/>
                </div>
            </div>

            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8'>
                {/* Stat Card 1 */}
                <div className='relative overflow-hidden bg-white bg-opacity-10 backdrop-blur-sm rounded-xl p-6 tranform hover:scale-105 transition-all duration-300 shadow-lg border border-white border-opacity-20'>
                    <div className='absolute -right-4 -top-4 w-20 h-20 rounded-full bg-white bg-opacity-10'/>
                    <div className='flex items-center justify-center w-16 h-16 rounded-full bg-white bg-opacity-20 mb-4 text-white'>
                        <Users size={30} />
                    </div>
                    <h3 className='font-display text-h1 text-white mb-2'>{counters.students}</h3>
                    <p className='text-white text-bodyRegular opacity-90'>Student Members</p>
                    <div className='absolute bottom-0 left-0 h-1 bg-cta w-full' />
                </div>

                {/* Stat Card 2 */}
                <div className='relative overflow-hidden bg-white bg-opacity-10 backdrop-blur-sm rounded-xl p-6 tranform hover:scale-105 transition-all duration-300 shadow-lg border border-white border-opacity-20'>
                    <div className='absolute -right-4 -top-4 w-20 h-20 rounded-full bg-white bg-opacity-10'/>
                    <div className='flex items-center justify-center w-16 h-16 rounded-full bg-white bg-opacity-20 mb-4 text-white'>
                        <BookOpen size={30} />
                    </div>
                    <h3 className='font-display text-h1 text-white mb-2'>{counters.tutorHours}+</h3>
                    <p className='text-white text-bodyRegular opacity-90'>Hours of Tutoring</p>
                    <div className='absolute bottom-0 left-0 h-1 bg-cta w-full' />
                </div>

                {/* Stat Card 3 */}
                <div className='relative overflow-hidden bg-white bg-opacity-10 backdrop-blur-sm rounded-xl p-6 tranform hover:scale-105 transition-all duration-300 shadow-lg border border-white border-opacity-20'>
                    <div className='absolute -right-4 -top-4 w-20 h-20 rounded-full bg-white bg-opacity-10'/>
                    <div className='flex items-center justify-center w-16 h-16 rounded-full bg-white bg-opacity-20 mb-4 text-white'>
                        <HeartHandshake size={30} />
                    </div>
                    <h3 className='font-display text-h1 text-white mb-2'>{counters.refugeesHelped}+</h3>
                    <p className='text-white text-bodyRegular opacity-90'>Refugees Helped</p>
                    <div className='absolute bottom-0 left-0 h-1 bg-cta w-full' />
                </div>
            </div>
        </section>
    )
}

export default ImpactStat